<template>
    <PlanbordGridRow>
        <PlanbordGridLeftDataColumns>
            <PlanbordGridCell info />
            <PlanbordFunctionCell />
            <PlanbordCommentCell />
            <PlanbordStampStartDateCell />
        </PlanbordGridLeftDataColumns>
        <template v-for="day in roster.days" :key="day.date.getTime()">
            <PlanbordGridCell :holiday="day.holiday" :weekend="day.weekend" :rosterEnded="day.ended" centeredHorizontally>
                <a class="requirement-edit-link" v-if="!day.ended" :href="roosterplanningHostUrl + '?pageid=P_ROOSTERWEB_COMP_OVV&rosterid=' + roster.rosterId + '&action=incidentalshiftbalance&date=' + (day.date.valueOf() / 1000).toFixed(0)" target="_blank"><span>✎</span></a>
            </PlanbordGridCell>
        </template>
    </PlanbordGridRow>
</template>

<script lang="ts">
    import {RosterData} from '@/types/types';
    import PlanbordGridRow from '@/components/Planbord/PlanbordGridRow.vue';
    import PlanbordGridLeftDataColumns from '@/components/Planbord/PlanbordGridLeftDataColumns.vue';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import PlanbordFunctionCell from '@/components/Planbord/PlanbordFunctionCell.vue';
    import PlanbordCommentCell from '@/components/Planbord/PlanbordCommentCell.vue';
    import PlanbordStampStartDateCell from '@/components/Planbord/PlanbordStampStartDateCell.vue';
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import RoosterplanningUrlBuilder from '@/util/RoosterplanningUrlBuilder';

    @Component({
        components: {
            PlanbordGridRow,
            PlanbordGridLeftDataColumns,
            PlanbordGridCell,
            PlanbordFunctionCell,
            PlanbordCommentCell,
            PlanbordStampStartDateCell,
        },
    })
    export default class LegacyWorkloadRequirementsEditLinks extends Vue {
        @Prop({required: true}) public roster!: RosterData;

        public get roosterplanningHostUrl(): string {
            return RoosterplanningUrlBuilder.getHostUrl() ?? '';
        }
    }
</script>

<style lang="scss" scoped>
    .requirement-edit-link {
        display: inline-block;
        text-decoration: none;
        color: var(--requirement-edit-link-color);
        border: 1px solid var(--requirement-edit-link-color);
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 0.75rem;
        text-align: center;

        &:hover {
            border-width: 2px;
        }
    }
</style>
